<template>
   <div class="mb-5 flex flex-col">
      <div class="flex cursor-pointer gap-2" @click="toggle">
         <div class="grow">
            <h3 class="h-l w-fit font-semibold">{{ title }}</h3>
         </div>

         <Icon
            name="plus"
            class="text-grey size-5 shrink-0 transition-all duration-300 md:size-8"
            :class="{
               'text-secondary': open,
               'rotate-45': open,
            }"
         />
      </div>

      <div
         class="grid transition-[grid-template-rows] duration-300"
         :class="open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
      >
         <div class="overflow-hidden">
            <div class="pt-4">
               <p v-if="content" class="p-m" v-html="$md(content)" />
               <slot v-else />
            </div>
         </div>
      </div>

      <Separator class="mt-8" />
   </div>
</template>

<script setup lang="ts">
type Props = {
   title: string
   content?: string
}
defineProps<Props>()

const open = ref<boolean>(false)

const toggle = () => {
   open.value = !open.value
}
</script>
